
export const TabType = {

};

/** 交易流水字段 */
export const TransactionFlowListFields = {
    /** 交易时间 */
    transactionTime: 'transTime',
    /** 账户外部编号 */
    accountOutNo: 'acctExtNo',
    /** 账户名称 */
    accountName: 'acctName',
    /** 交易名称 */
    transactionName: 'transName',
    /** 收支类型 */
    incomeOutType: 'loanMark',
    /** 交易金额 */
    transactionAmount: 'transAmt',
    /** 交易后余额 */
    transactionAfterAmount: 'postBal',
    /** 清算日期 */
    settleTime: 'settDate',
    /** 对方账号 */
    toAccount: 'otherAcctNo',
    /** 对方账户名 */
    toAccountName: 'otherAcctName',
    /** 对方账户外部编号 */
    toAccountOutNo: 'otherAcctExtNo',
    /** 交易备注 */
    remark: 'remark',
    /** 摘要 */
    summary: 'abst',
    /** 备用域1 */
    spareDomain1: 'def1',
    /** 订单号 */
    orderNo: 'orderNo',
    /** 商户订单号 */
    merchantOrderNo: 'mctOrderNo',
    /** 批次号 */
    batchNo: 'batchNo',
    /** 渠道商户名称 */
    channelMerchantName: 'chnlMerName',
    /** 资金渠道名称 */
    moneyChannelName: 'amtChnlName',
    /** 业务类型名称 */
    businessTypeName: 'bizTypeName',
    /** 业务商户号 */
    businessMerchantNo: 'bizMerNo'
};
